import * as React from "react";

interface DrawerDeliveryConsumerInterface {
  drawerShouldBePresenting: boolean;
}
const defaultValue = {} as unknown as DrawerDeliveryConsumerInterface;
const DrawerDeliveryContext = React.createContext(defaultValue);

interface DrawerDelivery_ControllerInterface {
  handleOpen: () => void;
  handleClose: () => void;
}
const controllerDefaultValue =
  {} as unknown as DrawerDelivery_ControllerInterface;
const DrawerDelivery_ControllerContext = React.createContext(
  controllerDefaultValue
);

interface DrawerDeliveryProviderProps {
  onlyUsedForOneTimePassword?: boolean;
}
export const DrawerDeliveryProvider: React.FunctionComponent<
  DrawerDeliveryProviderProps
> = (props) => {
  const [drawerShouldBePresenting, setDrawerShouldBePresenting] = React.useState(false);

  const handleOpen: DrawerDelivery_ControllerInterface["handleOpen"] =
    React.useCallback(() => {
      setDrawerShouldBePresenting(true);
    }, []);

  const handleClose: DrawerDelivery_ControllerInterface["handleClose"] =
    React.useCallback(() => {
      setDrawerShouldBePresenting(false);
    }, []);

  const value: DrawerDeliveryConsumerInterface = React.useMemo(
    () => ({
      drawerShouldBePresenting,
    }),
    [drawerShouldBePresenting]
  );
  const controllerValue: DrawerDelivery_ControllerInterface = React.useMemo(
    () => ({
      handleOpen,
      handleClose,
    }),
    [handleOpen, handleClose]
  );
  return (
    <DrawerDeliveryContext.Provider value={value}>
      <DrawerDelivery_ControllerContext.Provider value={controllerValue}>
        {props.children || []}
      </DrawerDelivery_ControllerContext.Provider>
    </DrawerDeliveryContext.Provider>
  );
};

export const useDrawerDelivery = () => {
  const value = React.useContext(DrawerDeliveryContext);

  if (value === defaultValue) {
    throw new Error(
      "useDrawerDelivery must be used within a DrawerDeliveryProvider"
    );
  }

  return value;
};

export const useDrawerDelivery_asController = () => {
  const value = React.useContext(DrawerDelivery_ControllerContext);

  if (value === controllerDefaultValue) {
    throw new Error(
      "useDrawerDelivery_asController must be used within a DrawerDeliveryProvider"
    );
  }

  return value;
};
